import React from 'react';
import './cardItemList.scss';
import { Link } from 'react-router-dom';
import { textConvertUrl, getDynamicProperty } from '../../../../core/hooks/textConvert';

export default function CardItemList({ data }: any) {
    return (
        <div className='content_elements'>
            {Object.keys(data).map((categoryKey, index) => (
                <div key={index} className="element">
                    <div className="header_element">
                        <h3 className="title">
                            <Link to={
                                data[categoryKey].id
                                    ? `/c/${textConvertUrl(data[categoryKey].title)}`
                                    : `/c/${textConvertUrl('alfabetico')}/${textConvertUrl(data[categoryKey].title)}`
                            } className='link'>
                                {data[categoryKey].title} <i className="fa-solid fa-arrow-right"></i>
                            </Link>
                        </h3>
                        <span className="count">{data[categoryKey].total} Artículo(s)</span>
                    </div>

                    <div className="body_element">
                        {Array.isArray(data[categoryKey].recent) && data[categoryKey].recent.slice(0, 5).map((element: any, subIndex: number) => (
                            <Link to={
                                `/a/${textConvertUrl(getDynamicProperty(element, 'slug'))}/${getDynamicProperty(element, 'id')}`
                            } key={subIndex} className='item'>
                                <i className='fa-regular fa-file'></i>
                                <span className='title'>{element.name_word}</span>
                            </Link>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}
